import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { TableAddorupdateComponent } from '../table-addorupdate/table-addorupdate.component';
declare var $;
@Component({
  selector: 'app-table-list',
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.css']
})
export class TableListComponent implements OnInit {
  // 素材Id
  @Input() materialId: any;
  // 删除弹框对象
  @Input() trim:any;
  // 点击图像跳转到指定页：抛出事件
  @Output() toPage = new EventEmitter(); 
  // 图像名称
  key = '';
  // 图像数据
  tables:any = [];
  // 分页参数
  pageBase: any = {
      current: 1,
      size: 10
  };
  constructor(
    private create: SwCreateModalComponentService,
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
    // 查询已标注的表格信息
    this.clickSearch();
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSearch();
    }
  }

  // 搜索
  clickSearch(){
    this.pageBase = {
      current: 1,
      size: 10
    }
    this.getData();
  }

  //获取数据
  getData() {
    const params = {
      'name': $.trim(this.key),
      'current': this.pageBase.current,
      'size': this.pageBase.size,
      'parentMaterialId': this.materialId,
	    'relType': 2,
    }
    this.kmsService.queryPicTableList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.pageBase = data.data;
          this.tables = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 重置
  clickReload(){
    this.key = '';
    this.clickSearch();
  }

  // 选择图像
  selectTable(item){
    this.toPage.emit(item.pagesNum);
  }

  // 新增表格
  clickAddTable(){
    let params = {
      upOrAdd: 'Add',
      materialRelId: '',
      materialId: this.materialId
    };
    this.create.createModal(TableAddorupdateComponent, params, this.clickSearch.bind(this));
  }

  // 编辑表格
  clickEditTable(materialRelId) {
    let params = {
        upOrAdd: 'Edit',
        materialRelId: materialRelId,
        materialId: this.materialId
    };
    this.create.createModal(TableAddorupdateComponent, params, this.clickSearch.bind(this));
  }

  // 删除表格
  clickDeleteTable(materialRelId) {
    this.trim.openCLick('是否删除当前表格？', (data) => {
        if (data) {
            let ids = [materialRelId];
            this.kmsService.delteMaterialRelById(ids).subscribe(
                data => {
                    if (data.code == '200') {
                        this.box.success('删除成功！');
                        this.clickSearch();
                    } else {
                        this.box.waring(data.msg);
                    }
                }
            );
        }
    });
  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase = event;
    this.getData();
  }
}
